import './PersonCard.css';

/**
 * Картка людини в керівництві.
 * Уся картка є кнопкою, що відкриває докладну інформацію: раніше клікабельною
 * була лише кнопка «Детальніше», що виїжджала з-під фото на наведення.
 */
export default function PersonCard({ personId, person, managementType, onOpen }) {
  const apiBase = process.env.REACT_APP_BASE_API_URL || '';
  const photo = person.photo?.url;

  const name = `${person.name?.trim() || ''} ${person.surname?.trim() || ''}`.trim();
  const role = managementType === 'regions' ? person.region : person.council_role;

  return (
    <div className='management-card-wrapper'>
      <button type='button' className='management-card' onClick={() => onOpen(personId)}>
        <span className='management-photo-wrapper'>
          {photo ? (
            <img src={`${apiBase}${photo}`} alt='' className='management-photo' loading='lazy' />
          ) : (
            <span className='management-photo management-photo--empty' aria-hidden='true' />
          )}
        </span>

        <span className='management-info'>
          <span className='management-name'>{name}</span>
          {role && <span className='management-role'>{role}</span>}
        </span>
      </button>
    </div>
  );
}
